import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PlayerForm from "../components/PlayerForm";
import { pickId } from "../utils";

const UserRegisterPage: React.FC = () => {
  const { gameId } = useParams();
  const [newPlayerId, setNewPlayerId] = useState<string | null>(null);

  useEffect(() => {
    const id = pickId();
    setNewPlayerId(id);
  }, []);

  if (!gameId) {
    return <div>Y U NO set gameId?</div>;
  }
  if (!newPlayerId) {
    return <div>Loading...</div>;
  }

  return <PlayerForm gameId={gameId} newPlayerId={newPlayerId} />;
};

export default UserRegisterPage;
